<template>
  <v-container>
    <v-row>
      <v-col>
        <v-btn
          to="/roles/create"
          small
        >
          <v-icon small>mdi-plus</v-icon>
          New role
        </v-btn>
      </v-col>
    </v-row>

    <app-search
      :attribute_list="search_attribute"
      @setSearchParam="setSearchParam"
    />

    <app-data-table
      :list_name="'role'"
      :header_list="headers"
      :attribute_list="attribute_list"
      :search_param="search_param"
      :url="`/roles`"
    />
  </v-container>
</template>

<script>
export default {
  name: "RoleList",
  components: {
    AppDataTable: () => import('../../../components/AppDataTable'),
    AppSearch: () => import('../../../components/AppSearch'),
  },
  data: () => ({
    headers: [
      { text: 'Id', value: 'id' },
      { text: 'Role', value: 'role_name' },
      { text: '', value: 'actions', sortable: false }
    ],
    search_attribute: ['role_name'],
    search_param: '',
    attribute_list: ['id', 'role_name'],
  }),
  methods: {
    setSearchParam (val) {
      this.search_param = val
    }
  },
};
</script>
